export default {
  'Contact': {
    'info': {
      'en': 'Reach out to us and help us improve further',
      'ko': null,
      'tr': null
    },
    'Subject': {
      'en': 'Subject',
      'ko': null,
      'tr': null
    }
  }
}
